import DEPRICATED_Dashboard from "./DEPRICATED_Dashboard";
export default DEPRICATED_Dashboard;
